import { Pipe, PipeTransform } from '@angular/core';
import { IconProviderService } from '../../whitelabel/services/icon-provider.service';
import { IconKey } from '../../../whitelabel/icon-key.enum';
import { IconsetKey } from '../../../whitelabel/iconset-key.enum';

@Pipe({
  name: 'icon',
  standalone: true,
})
export class IconPipe implements PipeTransform {

  constructor(private iconProvider: IconProviderService) {}

  transform(identifier: IconKey, iconset: IconsetKey | undefined = undefined): string {
    return this.iconProvider.getIcon(identifier, iconset);
  }
}
